<template>
	<v-container class="mt-4 ml-2" fluid>
	  <v-row>
	  	<v-col cols="12">
	  		<v-card class="shadowCard">
	  		  <v-card-title primary-title class="encabezado-becas">
	  		    <span class="text-subtitle-1">Becas alumnos</span>
	  		    <v-spacer></v-spacer>

	  		    <v-btn
              class="mr-2"
              small dark color="green"
              @click="descargarExcel()"
              tile
            >
              <v-icon small>mdi-microsoft-excel</v-icon>
            </v-btn>

            <v-btn
              v-if="acceso.control"
              color="teal"
              dark
              class="mr-2"
              @click="ligarAutomatico()"
              small
              tile
            >
              <v-icon left small>mdi-link-variant</v-icon>
              Ligar automático
            </v-btn>

            <v-btn
              v-if="acceso.vista"
              color="orange"
              dark
              class="mr-2"
              @click="abrirAlta()"
              small
              tile
            >
              <v-icon left small>mdi-plus</v-icon>
              Agregar
            </v-btn>

            <v-btn
              color="primary"
              dark
              class="text-capitalize"
              @click="initialize()"
              small
              tile
            >
              <v-icon left small>mdi-refresh</v-icon>
              Actualizar
            </v-btn>

	  		  </v-card-title>
	  		  <v-card-text>

	  		  	<v-row>
	  		  		<v-col cols="12" md="6" lg="5">
	  		  			<v-autocomplete
	  		  			  v-model="filtroFolio"
	  		  			  :items="opcionesFiltroFolio"
	  		  			  label="Folio (becas activas)"
	  		  			  filled
	  		  			  dense
	  		  			  hide-details
	  		  			  clearable
	  		  			></v-autocomplete>
	  		  		</v-col>
	  		  		<v-col cols="12" md="6" lg="5">
	  		  			<v-text-field
	  		  			  label="Buscar"
	  		  			  filled
	  		  			  dense
	  		  			  hide-details
	  		  			  append-icon="mdi-magnify"
	  		  			  v-model="search"
	  		  			></v-text-field>
	  		  		</v-col>
	  		  		<v-col cols="12" lg="2" class="d-flex align-center" v-if="acceso.control">
	  		  			<v-btn color="primary" small tile block :disabled="!seleccionadas.length" @click="folioLigar = null; dialogLigar = true">
	  		  				<v-icon left small>mdi-link</v-icon>
	  		  				Ligar {{ becasSeleccionadas.length || "" }} a folio
	  		  			</v-btn>
	  		  		</v-col>
	  		  	</v-row>

	  		    <v-row>
	  		    	<v-col cols="12">
							  <!-- Un renglón por alumno y folio; en "Ver becas" se ven sus becas por ciclo -->
							  <v-data-table
							    v-model="seleccionadas"
							    :headers="headersAlumno"
							    :items="alumnosAgrupados"
							    item-key="key"
							    :show-select="acceso.control"
							    class="elevation-0 tabla-becas"
							    :search="search"
							    :page.sync="page"
			            @page-count="pageCount = $event"
							    :mobile-breakpoint="100"
			            hide-default-footer
			            dense
							  >
							    <template v-slot:item.alumno="{ item }">
							      <div class="d-flex align-center">
							      	<v-chip
							      		v-if="item.es_familiar != null"
							      		class="chip-estatico mr-2 flex-shrink-0"
							      		x-small
							      		dark
							      		:color="Number(item.es_familiar) ? 'indigo' : 'teal'"
							      	>{{ Number(item.es_familiar) ? 'Familiar' : 'Propio' }}</v-chip>
							      	<div class="celda-truncada" :title="item.alumno">{{ item.alumno || 'Alumno no encontrado' }}</div>
							      </div>
							    </template>

							    <template v-slot:item.ciclos="{ item }">
							      <v-chip
							      	v-if="item.ciclos"
							      	small
							      	outlined
							      	color="primary"
							      	@click="ciclosDetalle = item; dialogCiclos = true"
							      >
							      	<v-icon left small>mdi-calendar-range</v-icon>
							      	{{ item.ciclos.split(', ').length }} {{ item.ciclos.split(', ').length === 1 ? 'ciclo' : 'ciclos' }}
							      </v-chip>
							    </template>

							    <template v-slot:item.folio_rh="{ item }">
							      <div v-if="item.folio_rh" :title="item.folio_rh + ' · ' + item.usuario_folio">
							      	{{ item.folio_rh }}
							      	<div class="text-caption celda-truncada">{{ item.usuario_folio }}</div>
							      </div>
							      <v-chip class="chip-estatico" v-else x-small color="grey" dark>Sin folio</v-chip>
							    </template>

							    <template v-slot:item.ver="{ item }">
							      <v-btn color="primary" x-small tile @click="detalle = item; dialogDetalle = true">Ver becas</v-btn>
							    </template>

							    <template v-slot:no-data>
							      <v-btn
							        color="primary"
							        @click="initialize"
							        small
							      >
							        Actualizar
							      </v-btn>
							    </template>

							  </v-data-table>
	  		    	</v-col>
	  		    </v-row>
	  		  </v-card-text>
	  		  <v-card-actions>
            <v-spacer></v-spacer>
            <v-pagination
              circle
              v-model="page"
              :length="pageCount"
              :total-visible="7"
            ></v-pagination>
          </v-card-actions>
	  		</v-card>
	  	</v-col>
	  </v-row>

    <!-- Ciclos en que el alumno ha tenido beca -->
    <v-dialog v-model="dialogCiclos" max-width="480px">
      <v-card v-if="ciclosDetalle">
        <v-card-title>
          <div class="text-subtitle-1">
            <div><strong>Nombre:</strong> {{ ciclosDetalle.alumno }}</div>
            <div><strong>Matrícula:</strong> {{ ciclosDetalle.matricula }}</div>
          </div>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogCiclos = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <div class="text-subtitle-2 mb-2">Ciclos con beca</div>
          <div class="d-flex flex-wrap" style="gap: 8px">
            <v-chip
              v-for="ciclo in ciclosDetalle.ciclos.split(', ')"
              :key="ciclo"
              class="chip-estatico"
              small
              outlined
              color="primary"
            >{{ ciclo }}</v-chip>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Becas del alumno por ciclo -->
    <v-dialog v-model="dialogDetalle" max-width="1200px" @input="(v) => { if (!v) detalle = null }">
      <v-card v-if="detalle">
        <v-card-title>
          <div class="text-subtitle-1">
            <div><strong>Nombre:</strong> {{ detalle.alumno }}</div>
            <div><strong>Matrícula:</strong> {{ detalle.matricula }}</div>
            <div><strong>Folio RH:</strong> {{ detalle.folio_rh ? detalle.folio_rh + ' · ' + detalle.usuario_folio : 'Sin folio' }}</div>
          </div>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogDetalle = false; detalle = null"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
							  <v-data-table
							    :headers="headersDetalle"
							    :items="detalle ? detalle.items : []"
							    item-key="id"
							    class="elevation-0"
							    hide-default-footer
							    disable-pagination
							    dense
							  >
							    <!-- Valores que ocupan botons, chips, iconos, etc -->
							    <template v-slot:item.beca="{ item }">
							      {{ item.beca }}%
							    </template>

							    <template v-slot:item.aprobadoSN="{ item }">
							      <v-chip class="chip-estatico"
							      	v-if="item.aprobadoSN == 1"
							      	small
							      	color="green"
							      	dark
							      >Si</v-chip>

							      <v-chip class="chip-estatico"
							      	v-else
							      	small
							      	color="error"
							      	dark
							      >No</v-chip>
							    </template>

							    <template v-slot:item.tipo_registro="{ item }">
							      <v-chip class="chip-estatico"
							      	v-if="item.tipo_registro == 1"
							      	small
							      	dark
							      >Empleado</v-chip>

							      <v-chip class="chip-estatico"
							      	v-else-if="item.tipo_registro == 4"
							      	small
							      	color="orange"
							      	dark
							      >Automática</v-chip>

							      <span v-else>{{ item.tipo_registro }}</span>
							    </template>

							    <template v-slot:item.actions="{ item }">
							    	<template v-if="item.aprobadoSN == 1">
								    	<v-btn
								    		color="primary"
								    		x-small
								    		@click="editItem(item)"
								    		class="mr-2"
								    	>
									      <v-icon small>mdi-pencil</v-icon>
								    	</v-btn>

								    	<v-btn
								    		color="error"
								    		x-small
								    		@click="deleteItem(item)"
								    		class="mr-2"
								    	>
									      <v-icon small> mdi-delete</v-icon>
								    	</v-btn>
							    	</template>
							    </template>
							  </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

	  <!-- Dialogo de editar o agregar-->
	  <v-dialog
      v-model="dialog"
      max-width="600px"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-subtitle-1">{{ editedId ? 'Editar beca' : 'Agregar beca' }}</span>
          <v-spacer></v-spacer>
          <span class="text-subtitle-1" v-if="editedId">
          	<strong>ID: {{ editedId }}</strong>
          </span>
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col cols="12">
             	<v-autocomplete
             		v-if="!editedId"
	              dense
	              filled
	              clearable
	              v-model="form.id_alumno"
	              :items="alumnos"
	              label="Alumno"
	              hide-details
	              item-text="datos_completos"
	              item-value="id_alumno"
	            ></v-autocomplete>
	            <v-text-field
	            	v-else
	            	:value="form.alumno"
	            	label="Alumno"
	            	filled
	            	dense
	            	hide-details
	            	readonly
	            ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6">
              <v-select
                v-model="form.idbeca"
                :items="catalogoBecas"
                item-text="texto"
                item-value="id"
                label="% Beca"
                filled
                dense
                :disabled="!!editedId && !Number(form.porcentaje_editable)"
                :hint="editedId && !Number(form.porcentaje_editable) ? 'Ciclo terminado: el % ya no se puede cambiar' : ''"
                persistent-hint
              ></v-select>
            </v-col>

            <v-col cols="12" sm="6" v-if="form.tipo_registro != 1">
              <v-text-field
                label="Cantidad de niveles"
                type="number"
                min="1"
                filled
                dense
                hint="Niveles en que se aplicará la beca al inscribir"
                persistent-hint
                v-model="form.cantidad"
              ></v-text-field>
            </v-col>

            <v-col cols="12">
              <v-autocomplete
                v-if="acceso.control"
                v-model="form.id_autorizacion"
                :items="folios"
                item-text="texto"
                item-value="id"
                label="Folio de quien autoriza"
                filled
                dense
                hide-details
                clearable
              ></v-autocomplete>
              <v-text-field
                v-else
                :value="acceso.folio ? acceso.folio.folio_rh + ' · ' + acceso.folio.trabajador : 'Sin folio RH activo'"
                label="Folio de quien autoriza"
                filled
                dense
                hide-details
                readonly
              ></v-text-field>
            </v-col>

            <v-col cols="12">
              <v-textarea
                v-model="form.motivo"
                label="Comentario"
                rows="3"
                filled
                dense
                hide-details
              ></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-btn
            color="dark"
            small
            dark
            tile
            @click="dialog = false"
          >
          	<v-icon left small>mdi-cancel</v-icon>
            Cancelar
          </v-btn>

          <v-spacer></v-spacer>

          <v-btn
            color="primary"
            dark
            small
            tile
            @click="save"
          >
          	<v-icon left small>mdi-content-save</v-icon>
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialogo para ligar varias becas a un folio -->
    <v-dialog v-model="dialogLigar" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="text-subtitle-1">Ligar {{ becasSeleccionadas.length }} beca(s) a folio</span>
        </v-card-title>
        <v-card-text>
          <v-autocomplete
            v-model="folioLigar"
            :items="folios"
            item-text="texto"
            item-value="id"
            label="Folio de quien autoriza"
            filled
            dense
            hide-details
          ></v-autocomplete>
        </v-card-text>
        <v-card-actions>
          <v-btn color="dark" small dark tile @click="dialogLigar = false">Cancelar</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" small tile :disabled="!folioLigar" @click="ligarSeleccionadas()">Ligar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialogo para eliminar -->
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
      	<v-card-text>
	      	<v-row justify="space-around">
	      		<v-col cols="6">
	      			<v-card class="elevation-0" height="100%" style="display: table;">
		      			<div class="text-subtitle-1" style="display: table-cell; vertical-align: middle;">
		      				<strong>Eliminar</strong> ¿Estás seguro que deseas dar de baja la beca?
			      			<v-card-actions class="pt-6">
			      				<!-- Cerrar dialogo de confirmación y abrir el dialogo de editar la clase -->
			      			  <v-btn color="error" text  class="mr-2" @click="dialogDelete = false">No, cancelar</v-btn>
			      			  <!-- Guardar la información  -->
			      			  <v-btn color="#5C5C5C"  dark class="elevation-6"  @click="deleteItemConfirm()">Si</v-btn>
			      			</v-card-actions>
		      			</div>
	      			</v-card>
	      		</v-col>
	      		<v-col cols="5">
	      			<v-img src="@/assets/borrar.png"></v-img>
	      		</v-col>
		      </v-row>
      	</v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

	</v-container>
</template>
<script>
	import XLSX from 'xlsx'
	// Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores        from '@/mixins/validarErrores'

  const formVacio = () => ({
    id_alumno: null,
    alumno: '',
    idbeca: null,
    cantidad: 1,
    motivo: '',
    id_autorizacion: null
  })

  export default {

    mixins: [ validarErrores ],

  	components:{
      Alerta,
      carga,
    },

    data: () => ({
    	// Alertas
    	parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      cargar: false,

      dialog: false,
      dialogDelete: false,
      dialogLigar: false,
      dialogDetalle: false,
      dialogCiclos: false,
      ciclosDetalle: null,
      detalle: null,

      acceso: { vista: false, control: false, folio: null },
      editedId: null,
      deleteId: null,
      form: formVacio(),

      // tabla
			search:'',
      page: 1,
      pageCount: 0,
      becas: [],
      seleccionadas: [],
      filtroFolio: null,
      folioLigar: null,

      alumnos:[],
      catalogoBecas: [],
      folios: [],
    }),

    computed: {
      headersAlumno () {
        // Anchos fijos para que la tabla no se reacomode al cambiar de página
        const headers = [
          { text: 'Alumno'          , value: 'alumno'    , width: '22%' },
          { text: 'Matrícula'       , value: 'matricula' , width: '112px' },
          { text: 'Beca'            , value: 'becas'     , width: '80px' },
          { text: 'Folio'           , value: 'folio_rh'  , width: '22%' },
          { text: 'Becas activas'   , value: 'activas'   , width: '96px', align: 'center' },
          { text: 'Ciclos con beca' , value: 'ciclos'    , width: '18%' },
          { text: 'Última alta'     , value: 'ultima'    , width: '160px' },
          { text: ''                , value: 'ver'       , width: '112px', sortable: false },
        ]
        if (this.acceso.control) headers.unshift({ text: '', value: 'data-table-select', width: '56px' })
        return headers
      },

      headersDetalle () {
        const headers = [
          { text: 'ID'            , value: 'id'             },
          { text: 'Grupo'         , value: 'grupo'          },
          { text: 'Beca'          , value: 'beca'           },
          { text: 'Aprobada'      , value: 'aprobadoSN'     },
          { text: 'Comentarios'   , value: 'comentarios'    },
          { text: 'Tipo registro' , value: 'tipo_registro'  },
          { text: 'Fecha alta'    , value: 'fecha_alta'     },
        ]
        if (this.acceso.control) headers.push({ text: 'Acciones', value: 'actions', sortable: false })
        return headers
      },

      becasFiltradas () {
        if (!this.filtroFolio) return this.becas
        if (this.filtroFolio === 'sin') return this.becas.filter((b) => !b.folio_rh)
        return this.becas.filter((b) => b.folio_rh === this.filtroFolio)
      },

      // Un renglón por alumno y folio, con sus becas y los ciclos en que las tuvo
      alumnosAgrupados () {
        const grupos = {}
        for (const b of this.becasFiltradas) {
          const key = b.id_alumno + '|' + (b.folio_rh || '')
          if (!grupos[key]) {
            grupos[key] = {
              key, id_alumno: b.id_alumno, alumno: b.alumno, matricula: b.matricula,
              folio_rh: b.folio_rh, usuario_folio: b.usuario_folio || b.trabajador_folio, es_familiar: b.es_familiar,
              items: [], porcentajes: new Set(), ciclosSet: new Set(), activas: 0, ultima: ''
            }
          }
          const g = grupos[key]
          g.items.push(b)
          g.porcentajes.add(b.beca + '%')
          const ciclo = String(b.grupo || '').match(/CICLO\s+[\w]+/i)
          if (ciclo) g.ciclosSet.add(ciclo[0].replace(/CICLO\s+/i, ''))
          if (Number(b.aprobadoSN) === 1) g.activas++
          if (String(b.fecha_alta) > g.ultima) g.ultima = String(b.fecha_alta)
        }
        return Object.values(grupos).map((g) => ({
          ...g,
          becas: [ ...g.porcentajes ].join(', '),
          ciclos: [ ...g.ciclosSet ].join(', ')
        }))
      },

      becasSeleccionadas () {
        return this.seleccionadas.flatMap((g) => g.items)
      },

      // Conteo de alumnos y becas activas por folio (quién y cuántas)
      opcionesFiltroFolio () {
        const porFolio = { sin: { folio: 'Sin folio', nombre: '', alumnos: new Set(), total: 0 } }
        for (const b of this.becas) {
          if (Number(b.aprobadoSN) !== 1) continue
          const k = b.folio_rh || 'sin'
          if (!porFolio[k]) {
            porFolio[k] = { folio: b.folio_rh, nombre: ' · ' + (b.usuario_folio || b.trabajador_folio || ''), alumnos: new Set(), total: 0 }
          }
          porFolio[k].alumnos.add(b.id_alumno)
          porFolio[k].total++
        }
        const texto = (f) => f.folio + f.nombre + ' (' + f.alumnos.size + (f.alumnos.size === 1 ? ' alumno, ' : ' alumnos, ') + f.total + ' becas)'
        const { sin, ...conFolio } = porFolio
        const opciones = Object.entries(conFolio)
          .sort((a, b) => b[1].alumnos.size - a[1].alumnos.size)
          .map(([ value, f ]) => ({ text: texto(f), value }))
        return [ { text: texto(sin), value: 'sin' }, ...opciones ]
      },
    },

    async created () {
      await this.initialize()
    },

    mounted () {
      window.addEventListener('keydown', this.cerrarConEsc, true)
    },

    beforeDestroy () {
      window.removeEventListener('keydown', this.cerrarConEsc, true)
    },

    methods: {
      // Esc cierra un modal a la vez, del de arriba al de abajo, aunque el foco haya quedado fuera
      cerrarConEsc (e) {
        if (e.key !== 'Escape') return
        const abierto = [ 'dialogDelete', 'dialogLigar', 'dialog', 'dialogCiclos', 'dialogDetalle' ].find((d) => this[d])
        if (!abierto) return
        e.stopPropagation()
        this[abierto] = false
        if (abierto === 'dialogDetalle') this.detalle = null
      },

      async initialize () {
      	this.cargar = true
        this.seleccionadas = []
        try {
          const [ becas, acceso ] = await Promise.all([ this.$http.get('becas.list'), this.$http.get('becas.acceso') ])
          this.becas  = becas.data
          this.acceso = acceso.data
          if (this.detalle) {
            this.detalle = this.alumnosAgrupados.find((g) => g.key === this.detalle.key) || null
            this.dialogDetalle = !!this.detalle
          }
          if (this.acceso.control && !this.folios.length) await this.getFolios()
        } catch (error) {
          this.validarError(error)
        } finally {
          this.cargar = false
        }
      },

      async getFolios () {
        const { data } = await this.$http.get('becas.folios')
        this.folios = data.map((f) => ({ id: f.id, texto: f.folio_rh + ' · ' + (f.usuario || f.trabajador) }))
      },

      async getCatalogos () {
        if (this.alumnos.length && this.catalogoBecas.length) return
        this.cargar = true
        try {
          const [ alumnos, catalogo ] = await Promise.all([ this.$http.get('descuentos.alumnos'), this.$http.get('inscripciones.becas') ])
          this.alumnos = alumnos.data
          this.catalogoBecas = catalogo.data
            .filter((b) => Number(b.activo_sn) === 1)
            .sort((a, b) => a.beca - b.beca)
            .map((b) => ({ id: b.id, texto: b.beca + '%' }))
        } catch (error) {
          this.validarError(error)
        } finally {
          this.cargar = false
        }
      },

      async abrirAlta () {
        this.editedId = null
        this.form = formVacio()
        await this.getCatalogos()
        this.dialog = true
      },

      async editItem (item) {
        this.editedId = item.id
        this.form = {
          id_alumno: item.id_alumno,
          alumno: item.alumno,
          idbeca: item.id_beca,
          cantidad: item.cantidad,
          motivo: item.comentarios,
          id_autorizacion: item.id_autorizacion,
          tipo_registro: item.tipo_registro,
          porcentaje_editable: item.porcentaje_editable
        }
        await this.getCatalogos()
        this.dialog = true
      },

      deleteItem (item) {
        this.deleteId = item.id
        this.dialogDelete = true
      },

      async deleteItemConfirm () {
      	this.cargar = true
        try {
          await this.$http.put('beca.deleted/' + this.deleteId)
          this.dialogDelete = false
          await this.initialize()
        } catch (error) {
          this.validarError(error)
        } finally {
          this.cargar = false
        }
      },

      async save () {
      	if (!this.form.idbeca || (!this.editedId && (!this.form.id_alumno || !this.form.cantidad))) {
      		return this.validarErrorDirecto('Favor de llenar alumno, % de beca y cantidad de niveles')
      	}
	      this.cargar = true
        try {
          if (this.editedId) {
            await this.$http.put('becas.update/' + this.editedId, this.form)
          } else {
            await this.$http.post('becas.add', this.form)
          }
          this.dialog = false
          await this.initialize()
          this.validarSuccess('Beca guardada')
        } catch (error) {
          this.validarError(error)
        } finally {
          this.cargar = false
        }
      },

      async ligarSeleccionadas () {
        this.cargar = true
        try {
          const { data } = await this.$http.put('becas.ligar.folio', {
            ids: this.becasSeleccionadas.map((b) => b.id),
            id_autorizacion: this.folioLigar
          })
          this.dialogLigar = false
          await this.initialize()
          this.validarSuccess(data.message)
        } catch (error) {
          this.validarError(error)
        } finally {
          this.cargar = false
        }
      },

      async ligarAutomatico () {
        this.cargar = true
        try {
          const { data } = await this.$http.post('becas.ligar.automatico')
          await this.initialize()
          this.validarSuccess(data.message)
        } catch (error) {
          this.validarError(error)
        } finally {
          this.cargar = false
        }
      },

      descargarExcel () {
        const filas = this.becasFiltradas.map((b) => ({
          ID: b.id,
          Alumno: b.alumno,
          Matrícula: b.matricula,
          Beca: b.beca,
          Aprobada: b.aprobadoSN == 1 ? 'Si' : 'No',
          Folio: b.folio_rh || 'Sin folio',
          Autoriza: b.usuario_folio || b.trabajador_folio || '',
          Comentarios: b.comentarios,
          Cantidad: b.cantidad,
          Restan: b.restan,
          'Fecha alta': b.fecha_alta
        }))
        const libro = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(libro, XLSX.utils.json_to_sheet(filas), 'Becas')
        XLSX.writeFile(libro, 'becas_alumnos_' + new Date().toISOString().slice(0, 10) + '.xlsx')
      },

    },
  }
</script>

<style scoped>
  .chip-estatico {
    pointer-events: none;
  }

  .encabezado-becas {
    gap: 8px;
  }

  /* Tabla de ancho y alto estables: no brinca al cambiar de página; en pantallas chicas se desplaza */
  .tabla-becas ::v-deep table {
    table-layout: fixed;
    min-width: 1040px;
  }

  .tabla-becas ::v-deep tbody td {
    height: 52px !important;
    font-variant-numeric: tabular-nums;
  }

  .celda-truncada {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>
